<div class="login-background">
    <div class="login-wrapper">

        <div class="login-title bold uk-margin-medium-top">S'enregistrer</div>


        <div uk-grid class="uk-padding-remove">

            <div class="uk-width-1-1 uk-margin-large-top" *ngIf="page === 1">
                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10 color-white">
                        Étape 1/2
                    </div>
                </div>
                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="text" placeholder="Adresse e-mail" [(ngModel)]="user.email">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="password" placeholder="Mot de passe" [(ngModel)]="user.password">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="password" placeholder="Confirmation du mot de passe" [(ngModel)]="passwordConfirmation">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline" style="width: calc(45% - 5px);">
                        <input class="uk-input input" type="text" placeholder="Prénom" [(ngModel)]="user.firstName">
                    </div>
                    <div class="uk-inline uk-margin-small-left" style="width: calc(45% - 5px)">
                        <input class="uk-input input" type="text" placeholder="Nom" [(ngModel)]="user.lastName">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10 uk-text-left">
                        <label><input class="uk-radio" name="radio" type="radio" [(ngModel)]="user.gender" [value]="'male'"> Homme</label>
                        <label><input class="uk-radio uk-margin-small-left" name="radio" type="radio" [(ngModel)]="user.gender" [value]="'female'"> Femme</label>
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="text" placeholder="Âge" [(ngModel)]="user.age">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="text" placeholder="Numéro de téléphone" [(ngModel)]="user.mobile">
                    </div>
                </div>

                <div class="uk-margin">
                    <div class="uk-inline uk-width-9-10">
                        <input class="uk-input input" type="text" placeholder="Code autopartage" [(ngModel)]="user.societyCode">
                    </div>
                </div>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top" *ngIf="page === 2">
            <div class="uk-margin">
                <div class="uk-inline uk-width-9-10 color-white">
                    Étape 2/2
                </div>
            </div>
            <div class="uk-margin">
                <label class="label uk-inline uk-width-9-10 color-white">
                    Permis de conduire (recto)
                </label>
                <div class="uk-form-controls uk-margin-small-top uk-inline uk-width-9-10 color-white">
                    <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(1)" type="button">
                        <span *ngIf="drivingRecto === null">Ajouter une photo</span>
                        <span *ngIf="drivingRecto && drivingRecto.name !== null">{{ drivingRecto.name }}</span>
                    </button>
                </div>
            </div>
            <div class="uk-margin">
                <label class="label uk-inline uk-width-9-10 color-white">
                    Permis de conduire (verso)
                </label>
                <div class="uk-form-controls uk-margin-small-top uk-inline uk-width-9-10 color-white">
                    <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(2)" type="button">
                        <span *ngIf="drivingVerso === null">Ajouter une photo</span>
                        <span *ngIf="drivingVerso && drivingVerso.name !== null">{{ drivingVerso.name }}</span>
                    </button>
                </div>
            </div>
            <div class="uk-margin">
                <label class="label uk-inline uk-width-9-10 color-white">
                    Justificatif d'identité (recto)
                </label>
                <div class="uk-form-controls uk-margin-small-top uk-inline uk-width-9-10 color-white">
                    <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(3)" type="button">
                        <span *ngIf="idRecto === null">Ajouter une photo</span>
                        <span *ngIf="idRecto && idRecto.name !== null">{{ idRecto.name }}</span>
                    </button>
                </div>
            </div>
            <div class="uk-margin">
                <label class="label uk-inline uk-width-9-10 color-white">
                    Justificatif d'identité (verso)
                </label>
                <div class="uk-form-controls uk-margin-small-top uk-inline uk-width-9-10 color-white">
                    <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(4)" type="button">
                        <span *ngIf="idVerso === null">Ajouter une photo</span>
                        <span *ngIf="idVerso && idVerso.name !== null">{{ idVerso.name }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="uk-width-1-1 uk-margin-large-top">
            <div class="uk-width-1-1 uk-margin-large-top">
                <button class="uk-button button login-button" (click)="register()">
                    <span class="bold" *ngIf="loadingAccountCreation === false && page === 1">Continuer</span>
                    <span class="bold" *ngIf="loadingAccountCreation === false && page === 2">Créer mon compte</span>
                    <span class="bold" *ngIf="loadingAccountCreation === true"><div uk-spinner></div></span>
                </button>
            </div>

            <div class="uk-width-1-1 uk-margin-large-top">
                <div class="uk-button button register-button default">
                    <span class="uk-margin-small-right">Vous avez déjà un compte?</span><br><span class="bold link pointer" [routerLink]="['/login']">Se connecter</span>
                </div>
            </div>
        </div>
    </div>

    <div style="position: absolute; bottom: 5px; right: 5px; color: white;">
        v{{ release }}
    </div>
</div>